import type { FirebaseAuthError } from "firebase-admin/lib/utils/error";
import * as auth from "firebase/auth";
import { authClient } from "shared/api/firebase";
import firebaseAuthErrorMessages from "./errorsMapping";

export const checkActiveSession = (): boolean =>
  Boolean(auth.getAuth().currentUser);

export const onAuthStateChanged = (
  callback: (a: auth.User | null) => any,
): auth.Unsubscribe => {
  return authClient.onAuthStateChanged(callback);
};

export const selectUser = (): auth.User | null => authClient.currentUser;

export const signIn = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}) => {
  try {
    await auth.signInWithEmailAndPassword(authClient, email, password);
  } catch (e: unknown) {
    const message =
      firebaseAuthErrorMessages[(e as FirebaseAuthError).code] ||
      "Unknown error";
    throw new Error(message);
  }
};

export const signOut = (): Promise<void> => auth.signOut(authClient);

export const sendPasswordResetEmail = async (email: string): Promise<void> => {
  const url =
    process.env.REACT_APP_NODE_ENV === "local"
      ? `https://${process.env.REACT_APP_AUTH_DOMAIN}/`
      : window.location.origin;

  const actionCodeSettings = {
    url,
  };

  await auth.sendPasswordResetEmail(authClient, email, actionCodeSettings);
};
